import React from 'react'
import { SkuCellProps } from './SkuCell.types'
import styles from './SkuCell.module.scss'
import cl from 'classnames'
import { ImageSquare, Text1 } from 'components/shared'
import { getMainImageSrcForObj } from 'utilities'

const SkuCellComponent = (props: SkuCellProps) => {
  const {
    sku
  } = props

  return (
    <div className={cl(styles.container)}>
      <ImageSquare
        src={getMainImageSrcForObj(sku)}
        width={30}
      />
      <span className={styles.numIndex}>
        ({sku.images.length})
      </span>
      <Text1 overflowEllipsis className={styles.skuId}>
        {sku.sku}
      </Text1>
    </div>
  )
}

const SkuCell = SkuCellComponent
export { SkuCell }
